module.exports = __webpack_public_path__ + "img/dike-banner.519c3411.png";